"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarraNavegacao = void 0;
var estiloBarraNavegacao = require("./BarraNavegacao.module.scss");
var react_1 = __importDefault(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var textoSecoes = [
    "ÁREA DO CLIENTE",
    "PORTAL DO CONHECIMENTO",
    "CADASTRAR TICKET",
    "MEUS TICKETS",
    "VERSÕES",
    "TREINAMENTOS",
    "MAPA DE UTILIZAÇÃO",
];
var BarraNavegacao = function (_a) {
    var onClick = _a.onClick, _b = _a.paginaAtual, paginaAtual = _b === void 0 ? 0 : _b;
    var handleClick = function (secao) {
        if (onClick) {
            onClick(secao);
        }
    };
    var secoes = [
        { texto: "ÁREA DO CLIENTE", index: 0 },
        { texto: "PORTAL DO CONHECIMENTO", index: 1 },
        { texto: "CADASTRAR TICKET", index: 2 },
        { texto: "MEUS TICKETS", index: 3 },
        { texto: "VERSÕES", index: 4 },
        { texto: "TREINAMENTOS", index: 5 },
        { texto: "MAPA DE UTILIZAÇÃO", index: 6, disabled: true },
    ];
    return (react_1.default.createElement("nav", { className: estiloBarraNavegacao.conteudo },
        react_1.default.createElement("ul", { className: estiloBarraNavegacao.lista }, secoes.map(function (secao, index) { return (react_1.default.createElement("li", { key: index, className: "".concat(estiloBarraNavegacao.itemLista, " ").concat(estiloBarraNavegacao[paginaAtual === index ? "ativo" : ""]), onClick: function () { return !secao.disabled && handleClick(secao); }, style: {
                cursor: secao.disabled ? "not-allowed" : "pointer",
                opacity: secao.disabled ? 0.5 : 1,
            } },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: paginaAtual === index ? "label1" : "label2", negrito: 700, cor: paginaAtual === index
                    ? Cores_1.Cores.GradacaoNeutros.PretoMU900
                    : Cores_1.Cores.GradacaoNeutros.CinzaFillMU400, style: { cursor: "inherit" } }, secao.texto))); }))));
};
exports.BarraNavegacao = BarraNavegacao;
